const queryKeys = {
    addressTypes: 'addressTypes',
    adminProductionPlans: 'adminProductionPlans',
    agreementListState: 'agreementListState',
    agreementsActive: 'agreementsActive',
    agreementsInactive: 'agreementsInactive',
    agreementsLockedCount: 'agreementsLockedCount',
    agreementsSearch: 'agreementsSearch',
    agreementsSearchWork: 'agreementsSearchWork',
    assetContractTypes: 'assetContractTypes',
    assetDownload: 'assetDownload',
    assetExport: 'assetExport',
    assetTypes: 'assetTypes',
    auth: 'auth',
    awards: 'awards',
    bindingMetadata: 'bindingMetadata',
    bookClubs: 'bookClubs',
    bookClubsMaterials: 'bookClubsMaterials',
    brands: 'brands',
    claimValues: 'claimValues',
    companyContacts: 'companyContacts',
    calculationGroup: 'calculationGroup',
    conceptCalculation: 'conceptCalculation',
    conceptProductionCosts: 'conceptProductionCosts',
    conceptsMy: 'conceptsMy',
    conceptsShared: 'conceptsShared',
    conceptThemas: 'conceptThemas',
    contact: 'contact',
    contactAgreements: 'contactAgreements',
    contactAssets: 'contactAssets',
    contactConcepts: 'contactConcepts',
    contactEditions: 'contactEditions',
    contactLinks: 'contactLinks',
    contactLists: 'contactLists',
    contactRetail: 'contactRetail',
    contactTextTypes: 'contactTextTypes',
    editionTextTypes: 'editionTextTypes',
    contactWorks: 'contactWorks',
    metadataCostCenters: 'metadataCostCenters',
    currencies: 'currencies',
    customerGroupsAndSubGroups: 'customerGroupsAndSubGroups',
    deliveryTypes: 'deliveryTypes',
    distributionAssignments: 'distributionAssignments',
    deforestationRegulationStatuses: 'deforestationRegulationStatuses',
    eanMetadata: 'eanMetadata',
    editionAssets: 'editionAssets',
    editionBookClubs: 'editionBookClubs',
    editionCosts: 'editionCosts',
    editionHistory: 'editionHistory',
    editionPrints: 'editionPrints',
    editionRoyaltyLevels: 'editionRoyaltyLevels',
    editionRoyaltyLevelsDefault: 'editionRoyaltyLevelsDefault',
    editionSalesTarget: 'editionSalesTarget',
    editionEstimatedSales: 'editionEstimatedSales',
    editionsCurrent: 'editionsCurrent',
    editionsMy: 'editionsMy',
    editionTexts: 'editionTexts',
    emailTemplate: 'emailTemplate',
    emailTemplates: 'emailTemplates',
    endPapersMetadata: 'endPapersMetadata',
    environment: 'environment',
    errorReportAgreementsState: 'errorReportAgreementsState',
    errorReportTermsState: 'errorReportTermsState',
    errorReportContactsState: 'errorReportContactsState',
    errorReportTransactionsState: 'errorReportTransactionsState',
    reportSettlementsState: 'reportSettlementsState',
    reportAdvancesState: 'reportAdvancesState',
    reportTermsRulesState: 'reportTermsRulesState',
    reportAgreementsState: 'reportAgreementsState',
    reportUpcomingSettlementsState: 'reportUpcomingSettlementsState',
    generalMetadata: 'generalMetadata',
    importPrices: 'importPrices',
    importStockChanges: 'importStockChanges',
    importTransactions: 'importTransactions',
    linkTypes: 'linkTypes',
    metadataActivitiesSearch: 'metadataActivitiesSearch',
    metadataActivity: 'metadataActivity',
    metadataAssetSearch: 'metadataAssetSearch',
    metadataConcept: 'metadataConcept',
    metadataConceptDetail: 'metadataConceptDetail',
    metadataConceptsSearch: 'metadataConceptsSearch',
    metadataContactsSearch: 'metadataContactsSearch',
    metadataCover: 'metadataCover',
    metadataEdition: 'metadataEdition',
    metadataEditionsSearch: 'metadataEditionsSearch',
    metadataInside: 'metadataInside',
    metadataPreliminaryCost: 'metadataPreliminaryCost',
    metadataPreliminaryEdition: 'metadataPreliminaryEdition',
    metadataPrintCost: 'metadataPrintCost',
    metadataPrinterPrices: 'metadataPrinterPrice',
    metadataTeam: 'metadataTeam',
    metadataType: 'metadataType',
    metadataTypes: 'metadataTypes',
    metadataWork: 'metadataWork',
    metadataWorkCreate: 'metadataWorkCreate',
    metadataWorksSearch: 'metadataWorksSearch',
    oneflowContracts: 'workContracts',
    oneflowTemplate: 'oneflowTemplate',
    oneflowEvents: 'oneflowEvents',
    paymentInformationHistory: 'paymentInformationHistory',
    paymentInformationUpcoming: 'paymentInformationUpcoming',
    productGroups: 'productGroups',
    productionDetailOptions: 'productionDetailOptions',
    productReplacement: 'productReplacement',
    products: 'products',
    reportExport: 'reportExport',
    retailers: 'retailers',
    royaltyBackgroundJobs: 'royaltyBackgroundJobs',
    salesChannels: 'salesChannels',
    salesChannelTranslations: 'salesChannelTranslations',
    salesTransactions: 'salesTransactions',
    searchAssets: 'searchAssets',
    searchActivities: 'searchActivities',
    searchContacts: 'searchContacts',
    searchConcepts: 'searchConcepts',
    searchAssetContractEditions: 'searchAssetContractEditions',
    searchAssetContractWork: 'searchAssetContractWork',
    searchContact: 'searchContact',
    searchEdition: 'searchEdition',
    searchEditions: 'searchEditions',
    searchEditionsByWorkIds: 'searchEditionsByWorkIds',
    searchThema: 'searchThema',
    searchWork: 'searchWork',
    searchWorks: 'searchWorks',
    selectionList: 'selectionList',
    selectionListContacts: 'selectionListContacts',
    selectionLists: 'selectionLists',
    settlementPeriod: 'settlementPeriod',
    settlements: 'settlements',
    standardCosts: 'standardCosts',
    statement: 'statement',
    statementPdfTemplates: 'statementPdfTemplates',
    statementReports: 'statementReports',
    statementReportsActive: 'statementReportsActive',
    statementReportsEnum: 'statementReportsEnum',
    statementReportsInactive: 'statementReportsInactive',
    statementReportsState: 'statementReportsState',
    transactionsSummary: 'transactionsSummary',
    technicalProductionTypes: 'technicalProductionTypes',
    thumbnailWidthSizes: 'thumbnailWidthSizes',
    upcomingSettlements: 'upcomingSettlements',
    user: 'user',
    userSettings: 'userSettings',
    userContacts: 'userContacts',
    work: 'work',
    workAssets: 'workAssets',
}

export default queryKeys

export const workCommunicationPlanKeys = {
    all: ['communicationPlan'] as const,
    details: () => [...workCommunicationPlanKeys.all, 'detail'] as const,
    detail: (id: number) => [...workCommunicationPlanKeys.details(), id] as const,
}

export const workLaunchPlanKeys = {
    all: ['launchPlan'] as const,
    details: () => [...workLaunchPlanKeys.all, 'detail'] as const,
    detail: (id: number) => [...workLaunchPlanKeys.details(), id] as const,
}
export const workLaunchPlanActivitiesKeys = {
    all: ['launchPlanActivities'] as const,
    details: () => [...workLaunchPlanActivitiesKeys.all, 'detail'] as const,
    detail: (id: number) => [...workLaunchPlanActivitiesKeys.details(), id] as const,
}

export const workRoyaltyKeys = {
    all: ['workRoyalty'] as const,
    details: () => [...workRoyaltyKeys.all, 'detail'] as const,
    detail: (id: number) => [...workRoyaltyKeys.details(), id] as const,
}

export const workReviewQuotesKeys = {
    all: ['workReviewQuotes'] as const,
    details: () => [...workReviewQuotesKeys.all, 'detail'] as const,
    detail: (id: number) => [...workReviewQuotesKeys.details(), id] as const,
}

export const editionAssetsKeys = {
    all: ['editionAssets'] as const,
    lists: () => [...editionAssetsKeys.all, 'list'] as const,
    list: (id: number) => [...editionAssetsKeys.lists(), { id }] as const,
}

export const editionTransactionSummaryKeys = {
    all: ['editionTransactionSummary'] as const,
    lists: () => [...editionTransactionSummaryKeys.all, 'list'] as const,
    list: (id: number) => [...editionTransactionSummaryKeys.lists(), { id }] as const,
}

export const editionPrintChangeKeys = {
    all: ['editionPrintChanges'] as const,
    lists: () => [...editionPrintChangeKeys.all, 'list'] as const,
    list: (id: number) => [...editionPrintChangeKeys.lists(), { id }] as const,
}

export const editionTextsKeys = {
    all: ['editionTexts'] as const,
    lists: () => [...editionTextsKeys.all, 'list'] as const,
    list: (id: number) => [...editionTextsKeys.lists(), { id }] as const,
}

export const editionEducationKeys = {
    all: ['editionEducation'] as const,
    details: () => [...editionEducationKeys.all, 'detail'] as const,
    detail: (id: number) => [...editionEducationKeys.details(), { id }] as const,
}

export const workAssetsKeys = {
    all: ['workAssets'] as const,
    lists: () => [...workAssetsKeys.all, 'list'] as const,
    list: (id: number) => [...workAssetsKeys.lists(), { id }] as const,
}

export const workThemasKeys = {
    all: ['workThemas'] as const,
    lists: () => [...workThemasKeys.all, 'list'] as const,
    list: (id: number) => [...workThemasKeys.lists(), { id }] as const,
}

export const advanceKeys = {
    all: ['advances'] as const,
    lists: () => [...advanceKeys.all, 'list'] as const,
    list: (id: number) => [...advanceKeys.lists(), { id }] as const,
    details: () => [...advanceKeys.all, 'detail'] as const,
    detail: (id: number) => [...advanceKeys.details(), id] as const,
}

export const standardCostKeys = {
    all: ['standardCosts'] as const,
    lists: () => [...standardCostKeys.all, 'list'] as const,
    list: (id: number) => [...standardCostKeys.lists(), { id }] as const,
    details: () => [...standardCostKeys.all, 'detail'] as const,
    detail: (id: number) => [...standardCostKeys.details(), id] as const,
}

export const deliverySpecificationKeys = {
    all: ['deliverySpecification'] as const,
    lists: () => [...deliverySpecificationKeys.all, 'list'] as const,
    list: (id?: number | null) => [...deliverySpecificationKeys.lists(), { id }] as const,
    details: () => [...deliverySpecificationKeys.all, 'detail'] as const,
    detail: (id: number) => [...deliverySpecificationKeys.details(), id] as const,
}

export const printChangesKeys = {
    all: ['printChanges'] as const,
    lists: () => [...printChangesKeys.all, 'list'] as const,
    list: (id: number) => [...printChangesKeys.lists(), { id }] as const,
    details: () => [...printChangesKeys.all, 'detail'] as const,
    detail: (id: number) => [...printChangesKeys.details(), id] as const,
}

export const termsRuleSetKeys = {
    all: ['termsRuleSets'] as const,
    lists: () => [...termsRuleSetKeys.all, 'list'] as const,
    list: (id: number) => [...termsRuleSetKeys.lists(), { id }] as const,
    details: () => [...termsRuleSetKeys.all, 'detail'] as const,
    detail: (id: number) => [...termsRuleSetKeys.details(), id] as const,
}

export const assetThumbnailKeys = {
    all: ['assetThumbnail'] as const,
    lists: () => [...assetThumbnailKeys.all, 'list'] as const,
    list: (id: number) => [...assetThumbnailKeys.lists(), { id }] as const,
}

export const activityKeys = {
    all: ['activity'] as const,
    lists: () => [...activityKeys.all, 'list'] as const,
    list: (id: number) => [...activityKeys.lists(), { id }] as const,
    details: () => [...activityKeys.all, 'detail'] as const,
    detail: (id: number) => [...activityKeys.details(), id] as const,
}

export const metadataKeys = {
    all: ['metadata'] as const,
    lists: () => [...metadataKeys.all, 'list'] as const,
    list: (id: string) => [...metadataKeys.lists(), { id }] as const,
}

export const conceptThemasKeys = {
    all: ['concepthemas'] as const,
    lists: () => [...conceptThemasKeys.all, 'list'] as const,
    list: (id: number) => [...conceptThemasKeys.lists(), { id }] as const,
}

export const workCostsKeys = {
    all: ['WorkCosts'] as const,
    details: () => [...workCostsKeys.all, 'detail'] as const,
    detail: (id: number) => [...workCostsKeys.details(), id] as const,
}

export const editionCostsKeys = {
    all: ['EditionCosts'] as const,
    details: () => [...editionCostsKeys.all, 'detail'] as const,
    detail: (id: number) => [...editionCostsKeys.details(), id] as const,
}

export const deforestationRegulationKeys = {
    all: ['DeforestationRegulation'] as const,
    details: () => [...deforestationRegulationKeys.all, 'detail'] as const,
    detail: (id: number) => [...deforestationRegulationKeys.details(), id] as const,
}
